@if (threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.ERROR ||
threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.INTERRUPTED ||
threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.PAUSED) {
<div class="w-full">

    <!-- Prompt-reuse / prompt-enhancement interrupts are edit-only actions -->
    @if (threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.INTERRUPTED
    && threadMessagesService.promptReuseSuggestion() && canEdit) {
    <app-prompt-reuse-card [candidates]="threadMessagesService.promptReuseSuggestion()!"
        (useExisting)="onUseExistingPrompt($event)" (generateNew)="onGenerateNewPrompt()" />
    } @else if (threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.INTERRUPTED
    && threadMessagesService.promptEnhancement() && canEdit) {
    <!-- Prompt-enhancement interrupt: render the PromptEnhancementCardComponent -->
    <app-prompt-enhancement-card [plan]="threadMessagesService.promptEnhancement()!" [pauseTimer]="pauseTimer"
        (approve)="onApprovePlan()" (editApprove)="onEditPlan($event)" (dismiss)="onRejectPlan()"
        (reviseRequested)="onRevisePlan($event)" (savePrompt)="onSavePrompt($event)" />
    } @else {

    <!-- Generic interrupt / error / paused card -->
    <div class="bg-white border border-gray-200 rounded-xl px-4 py-3 shadow-sm flex flex-col gap-2">
        <div class="flex gap-2 items-center">
            <div class="flex-shrink-0">
                @if (threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.PAUSED &&
                threadMessagesService.threadPauseReason() === 'server_restart') {
                <app-icon [type]="'refresh-cw'" [source]="'lucide'" [class]="'h-4 w-4 text-blue-500'"
                    [size]="'sm'"></app-icon>
                } @else {
                <app-icon [type]="'circle-alert'" [source]="'lucide'" [class]="'h-4 w-4 text-gray-600'"
                    [size]="'sm'"></app-icon>
                }
            </div>
            <div class="flex-1 min-w-0">
                @if (threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.ERROR) {
                <p class="text-sm font-medium text-black">{{ threadMessagesService.errorMessage() || 'Agent terminated
                    due to error' }}</p>
                } @else if (threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.INTERRUPTED) {
                <p class="text-sm font-medium text-black">{{ canEdit ? 'The agent is awaiting your consent to proceed' :
                    'The agent is awaiting the owner\'s consent to proceed' }}</p>
                } @else if (threadMessagesService.threadPauseReason() === 'server_restart') {
                <p class="text-sm font-medium text-black">System is resetting, please wait</p>
                }
                @else if (threadMessagesService.threadPauseReason() === 'credits_exhausted') {
                @if (creditsOverviewRef.creditsAvailable()) {
                <p class="text-sm font-medium text-black">{{
                    canEdit ?
                    'Credits topped up. Continue to resume where you left off.' :
                    'Credits topped up. Owner can now resume where its left off.'
                    }}
                </p>
                } @else {
                <p class="text-sm font-medium text-black">
                    {{ canEdit ?
                    'Credits exhausted , Please Request more to continue.' :
                    'Credits exhausted , Owner needs to request more credits to continue.' }}</p>
                }

                }@else {
                <p class="text-sm font-medium text-black">{{ canEdit ? 'Thread paused by you' : 'Thread paused by the
                    owner.' }}</p>
                }
            </div>
            @if (threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.INTERRUPTED && startTimer &&
            canEdit) {
            <div class="flex items-center gap-2 text-sm text-gray-700 bg-gray-100 px-3 py-1.5 rounded-full"
                [class.timer-pulse]="timeRemaining() <= 10">
                <span class="text-xs font-mono">{{ formatTime(timeRemaining()) }}</span>
            </div>
            }
        </div>

        @if (canEdit) {
        <div>
            @if (threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.INTERRUPTED ) {
            <p class="text-xs text-gray-600">Waiting for your approval or send a message to continue</p>
            } @else if (threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.PAUSED &&
            threadMessagesService.threadPauseReason() === 'server_restart') {
            <p class="text-xs text-gray-600">The thread will resume automatically once the system is back online</p>
            } @else if (threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.PAUSED) {
            <p class="text-xs text-gray-600">Click Continue to resume where you left off</p>
            } @else {
            <p class="text-xs text-gray-600">Send a message to continue</p>
            }
        </div>

        <!-- Action buttons — only shown to users with edit rights -->
        @if (threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.ERROR) {
        <div class="flex gap-2 justify-end">
            <app-button variant="outlined" severity="contrast" size="sm" (clicked)="onContinueAfterError()"
                [enableThrottle]="true" label="Continue" />
        </div>
        } @else if (threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.INTERRUPTED) {
        <div class="flex gap-2 justify-end">
            <app-button [icon]="'x'" [iconSource]="'lucide'" [size]="'sm'" (clicked)="onRejectPlan()"
                [enableThrottle]="true" label="Dismiss" />
            <app-button [icon]="'check'" [iconSource]="'lucide'" [size]="'sm'" severity="success"
                (clicked)="onApprovePlan()" [enableThrottle]="true" label="Accept" />
        </div>
        }
        @else if (threadMessagesService.threadPauseReason() === 'credits_exhausted') {
        <div class="flex gap-2 justify-end">
            @if (creditsOverviewRef.creditsAvailable()) {
            <app-button [icon]="'play'" [iconSource]="'lucide'" [size]="'sm'" severity="success"
                (clicked)="onContinueAfterPause()" [enableThrottle]="true" label="Continue" />
            } @else {
            <span
                [pTooltip]="!canRequestCredits ? 'Enable at least one of agent or ask mode to add credits' : undefined"
                tooltipPosition="top" class="inline-flex">
                <app-button (clicked)="creditsOverviewRef.openRequestDialog()" variant="filled" severity="primary"
                    [enableThrottle]="true" label="Get Credits" [disabled]="!canRequestCredits" />
            </span>
            }
        </div>
        } @else if (threadMessagesService.threadMetadataStatus() === THREAD_METADATA_STATUS.PAUSED &&
        threadMessagesService.threadPauseReason() !== 'server_restart') {
        <div class="flex gap-2 justify-end">
            <app-button [icon]="'play'" [iconSource]="'lucide'" [size]="'sm'" severity="success"
                (clicked)="onContinueAfterPause()" [enableThrottle]="true" label="Continue" />
        </div>
        }
        }
    </div>

    } <!-- end @else (generic card) -->
</div>
}

<app-credits-overview #creditsOverviewRef class="hidden" [needHeader]="false" [needActionButtons]="false"
    [askModeEnabled]="askModeEnabled" [agentModeEnabled]="agentModeEnabled" />